import httpAdminClient from '@/plugins/httpAdminClient';

export default {
  index(params = {}) {
    return httpAdminClient.get('admin/meeting/appointments', { params });
  },
  update(data) {
    return httpAdminClient.patch(`admin/meeting/appointments/${data.id}`, { meeting_appointment: { ...data } });
  },
  apply(id) {
    return httpAdminClient.post(`admin/meeting/appointments/${id}/apply`, {});
  },
  reject(id) {
    return httpAdminClient.post(`admin/meeting/appointments/${id}/reject`, {});
  },
};



// WEBPACK FOOTER //
// ./src/apiSet/adminApis/meeting/appointmentsApis.js